import apiClient from './client';

export const usersApi = {
  getUsers: () => apiClient.get('/api/users'),
  getUserById: (id) => apiClient.get(`/api/users/${id}`),
  updatePrimaryBot: (data) => apiClient.put('/api/users/p-bot', data),
  getDashboardStats: () => apiClient.get('/api/users/dashboard'),
  getCountries: (params) => apiClient.get('/api/users/countries', { params }),
  createAgent: (data) => {
    const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
    return apiClient.post('/api/users/agents', data, isFormData ? {
      headers: { 'Content-Type': 'multipart/form-data' },
    } : undefined);
  },
  updateAgent: (id, data) => {
    const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
    return apiClient.put(`/api/users/agents/${id}`, data, isFormData ? {
      headers: { 'Content-Type': 'multipart/form-data' },
    } : undefined);
  },
  updateAgentStatus: (id, data) => apiClient.put(`/api/users/agents/${id}/status`, data),
  getNotifications: (params) => apiClient.get('/api/users/notifications', { params }),
  markNotificationRead: (id) => apiClient.put(`/api/users/notifications/${id}/read`),
  deleteAgent: (id) => apiClient.delete(`/api/users/agents/${id}`),
};

export default usersApi;
